function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 1C5.93436 1 1 5.93436 1 12C1 18.0656 5.93436 23 12 23C18.0656 23 23 18.0656 23 12C23 5.93436 18.0656 1 12 1ZM17.2314 17.6897C17.0527 17.8684 16.818 17.9584 16.5834 17.9584C16.3487 17.9584 16.1139 17.8684 15.9353 17.6897L11.3519 13.1064C11.1796 12.9351 11.0834 12.7021 11.0834 12.4584V6.5C11.0834 5.9931 11.4939 5.58339 12 5.58339C12.5061 5.58339 12.9166 5.9931 12.9166 6.5V12.0789L17.2314 16.3936C17.5898 16.7521 17.5898 17.3313 17.2314 17.6897Z",
  fill: "#373737"
});

function SvgTimeofday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeofday);
export default __webpack_public_path__ + "static/media/timeofday.58064992.svg";
export { ForwardRef as ReactComponent };